<button type="button" class="icon-button" [disabled]="readonly" (click)="handleClick($event)">
  <app-svg-icon [path]="path"></app-svg-icon>
</button>
